<div class="login-container">
    <div class="login">
        <h1 class="login-title">Stocks</h1>
        <button (click)="signIn()" class="login-button">
            <i class="fab fa-google"></i> 
            &nbsp;
            <span>Log In With Google</span>
        </button>
    </div>
</div>
<p-toast position="bottom-left"></p-toast>